<template>
    <section class="product" :checked.prop="product.isVisible" v-show="isThatVisible" :is-visible.prop="product.isVisible">
        <h3><span>{{ product.code }}</span>. {{ product.title }}</h3>
        <template v-for="activity in product.activities">
            <activity :key="activity.code" :activity="activity" />
        </template>
    </section>
</template>
<script>
import Activity from '@/components/Activity.vue';
export default {
    name: "Product",
    components: { Activity },
    props: {
        product: {
            type: Object,
            default: () => {}
        },
    },
    computed: {
        hasActivities() {
            return this.product.activities && this.product.activities.lenght
        },
        isThatVisible() {
            return this.product.isVisible
        }
    },
}
</script>
<style scoped> 
    .product {
        margin-bottom: 2.5rem;
    }   
    .product h3::after {
        content: none;
    }
    .product h3 {
        font-size: 1.2em;
        color: var(--color-txt);
        background-color: var(--bg-sections);
        padding: .8em;
        border-left: 5px solid var(--primary);
        font-weight: 700;
    }
</style>